export default __webpack_public_path__ + "static/media/breakfast4.55e70351.png";